import React from "react";
import KPICard from "./KPICard";

const KPICardsGrid = ({ cards, compareYear }) => {
  return (
    <div className="analytics-kpi-grid">
      {cards?.map((card, index) => {
        let changePercent = card.changePercent;
        let changeType = card.changeType || "negative";

        if (card.change !== undefined && card.change !== null) {
          changeType = card.change >= 0 ? "positive" : "negative";
          changePercent = card.isPercentage
            ? `${card.change > 0 ? "+" : ""}${card.change} pp`
            : `${card.change > 0 ? "+" : ""}${card.change}%`;
        }

        return (
          <KPICard
            key={index}
            label={card.label}
            tooltipTitle={card.tooltipTitle}
            value={card.value}
            changePercent={changePercent}
            changeType={changeType}
            prevValue={card.prevValue}
            compareYear={compareYear}
          />
        );
      })}
    </div>
  );
};

export default KPICardsGrid;
